import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { InputGroup, InputGroupAddon, Button, Input } from 'reactstrap';

import actions from './actions';
import {
  isApartamentoValid,
  isDataFuturaValid
} from './../../utils/validation';

import AuthProvider from '../../AuthProvider';

class CadastroReserva extends Component {
  constructor(props) {
    super(props);

    this.checkin = this.checkin.bind(this);
  }

  checkin(e) {
    e.preventDefault();

    if (this.isValid()) {
      this.props.actions.onCreateReservas({
        value: this.props.value.data
      });
    }
  }

  isValid() {
    let { unidade, data_reserva } = this.props.value.data;

    let errors = [];
    if (!isApartamentoValid(unidade)) {
      errors.push('Número do apartamento inválido');
    }
    if (!isDataFuturaValid(data_reserva)) {
      errors.push('Data da reserva inválida');
    }

    if (errors.length) {
      alert('Erros encontrados:\n - ' + errors.join('\n - '));
    }

    return !errors.length;
  }

  handleChange(field, sanitize = /[^\d\w áéíóúàâêôãõç]+/gi) {
    let { actions } = this.props;

    return e => {
      let value = this.props.value.data[field];
      if (e.target.valueAsNumber || !e.target.value) {
        value = e.target.value;
      }

      actions.onChange(
        field,
        value
          .replace(/^\s+|\s+(?=\s$|\s)/g, '')
          .toUpperCase()
          .replace(sanitize, '')
      );
    };
  }

  render() {
    let { value } = this.props;
    let { fetching, data } = value;
    let toDate = d =>
      [
        d.getUTCFullYear(),
        ('0' + (1 + d.getUTCMonth())).slice(-2),
        d.getUTCDate()
      ].join('-');
    let today = new Date();
    today.setHours(0, -today.getTimezoneOffset(), 0, 0);

    return (
      <AuthProvider>
        {({ auth: activeAuth }, containsRole, constainsUnidade) => {
          let isPermiteUnidade = containsRole([
            'admin',
            'sindico',
            'conselheiro',
            'porteiro',
            'zelador'
          ]);
          let unidades = constainsUnidade(['proprietario', 'morador'])(null);
          let isUnidadeValid =
            (!data.unidade && 1 === unidades.length) ||
            /^[0-3]?\d0[1-4]$/.test(data.unidade);

          return (
            (isPermiteUnidade || 0 < unidades.length) && (
              <form onSubmit={this.checkin}>
                <InputGroup className="fcr-container" disabled={1 === fetching}>
                  {(isPermiteUnidade || 1 < unidades.length) && (
                    <Input
                      className="fcr-input-unidade"
                      value={data.unidade}
                      required={1 !== unidades.length}
                      type="number"
                      valid={isUnidadeValid}
                      placeholder="Apartamento"
                      maxLength="4"
                      min="101"
                      max="3304"
                      onChange={this.handleChange('unidade', /\D+/g)}
                    />
                  )}
                  <Input
                    className="fcr-input-data_reserva"
                    value={data.data_reserva}
                    required
                    type="date"
                    placeholder="Data"
                    pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
                    valid={isDataFuturaValid(data.data_reserva)}
                    min={toDate(today)}
                    onChange={this.handleChange('data_reserva', /[^\d/-]+/g)}
                  />
                  <InputGroupAddon addonType="append">
                    {1 !== fetching && (
                      <Button
                        className="fcr-button-agendar"
                        type="submit"
                        color="success"
                        disabled={
                          !(
                            isUnidadeValid &&
                            isDataFuturaValid(data.data_reserva)
                          )
                        }
                        title="Agendar!"
                      >
                        <span className="fa fa-calendar-plus" />{' '}
                        <span className="d-none d-md-inline-block">
                          Agendar!
                        </span>
                      </Button>
                    )}
                    {1 === fetching && (
                      <Button
                        color="dark"
                        disabled={true}
                        title="Carregando..."
                      >
                        <span className="fa fa-spinner fa-spin" />{' '}
                        <span className="d-none d-md-inline-block">
                          Carregando...
                        </span>
                      </Button>
                    )}
                  </InputGroupAddon>
                </InputGroup>
                <br />
              </form>
            )
          );
        }}
      </AuthProvider>
    );
  }
}

let mapStateToProps = ({ reserva }) => ({
  value: reserva
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CadastroReserva);



// WEBPACK FOOTER //
// ./src/modules/reserva/CadastroReserva.js